import {
  Truck,
  Package2,
  PiggyBank,
  Phone,
  CheckCircle2,
  TrendingDown,
  Warehouse,
  Clock,
} from "lucide-react";
import { Button } from "../ui/button";
import { COMPANY } from "../../data/products";

const BENEFITS = [
  {
    icon: TrendingDown,
    title: "Najlepsze ceny w Polsce",
    text: "Pomijamy pośredników — kupujesz prosto od dystrybutora. Ceny niższe nawet o 30% niż w marketach budowlanych.",
  },
  {
    icon: Truck,
    title: "Darmowa dostawa od 4 palet",
    text: "Zamawiasz minimum 4 palety wełny? Dowozimy własnym transportem na koszt firmy. Cała Polska.",
  },
  {
    icon: Warehouse,
    title: "Sprzedaż hurtowa",
    text: "Specjalne warunki dla firm wykonawczych, składów budowlanych i wspólnot mieszkaniowych.",
  },
  {
    icon: Clock,
    title: "Szybka realizacja",
    text: "Wysyłka w 24-72 h od zaksięgowania zamówienia. Towar zawsze dostępny z magazynu.",
  },
];

export default function Wholesale() {
  return (
    <section
      id="hurt"
      data-testid="wholesale-section"
      className="bg-white py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero strip — delivery offer */}
        <div className="relative bg-red-600 text-white border-2 border-red-600 mb-16 overflow-hidden">
          <div className="absolute -right-10 -top-10 h-64 w-64 bg-red-700 rounded-full opacity-50 hidden lg:block" />
          <div className="absolute -left-20 -bottom-20 h-72 w-72 border-[16px] border-red-500 rotate-12 opacity-40 hidden lg:block" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 p-8 lg:p-12 items-center">
            <div className="lg:col-span-7">
              <div className="flex items-center gap-3 mb-4">
                <Truck className="h-7 w-7" strokeWidth={2} />
                <span className="font-tech text-xs tracking-[0.3em] uppercase font-bold text-red-100">
                  Promocja stała
                </span>
              </div>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-none tracking-tighter mb-4">
                Darmowa dostawa<br />
                od <span className="bg-black px-3 py-1 inline-block">{COMPANY.freeDeliveryFromPallets} palet</span>
              </h2>
              <p className="text-red-50 text-lg leading-relaxed max-w-2xl">
                Zamów minimum {COMPANY.freeDeliveryFromPallets} palety wełny mineralnej szklanej i
                otrzymasz transport <strong>gratis</strong> na terenie całej Polski.
                Bez ukrytych kosztów, bez minimalnej wartości zamówienia.
              </p>
            </div>
            <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col gap-3">
              <Button
                asChild
                className="rounded-none bg-black hover:bg-zinc-800 text-white font-bold uppercase tracking-wider h-14 text-base flex-1"
                data-testid="wholesale-cta-order"
              >
                <a href="#kontakt">
                  <Package2 className="mr-2 h-5 w-5" />
                  Zamów ofertę hurtową
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                className="rounded-none bg-transparent border-2 border-white text-white hover:bg-white hover:text-red-600 font-bold uppercase tracking-wider h-14 text-base flex-1"
                data-testid="wholesale-cta-call"
              >
                <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}>
                  <Phone className="mr-2 h-5 w-5" />
                  {COMPANY.phone}
                </a>
              </Button>
            </div>
          </div>
          {/* Diagonal stripe bottom */}
          <div className="h-2 bg-stripes" />
        </div>

        {/* 4 benefits grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border-2 border-black">
          {BENEFITS.map((b, idx) => (
            <div
              key={b.title}
              data-testid={`wholesale-benefit-${idx}`}
              className={`p-7 lg:p-8 bg-white hover:bg-zinc-900 hover:text-white transition group relative ${
                idx !== BENEFITS.length - 1 ? "lg:border-r-2 border-black" : ""
              } ${idx % 2 === 0 ? "md:border-r-2 lg:border-r-2" : ""} ${
                idx < 2 ? "md:border-b-2 lg:border-b-0 border-black" : ""
              }`}
            >
              <b.icon
                className="h-10 w-10 text-red-600 group-hover:text-red-500 transition mb-5"
                strokeWidth={1.6}
              />
              <h3 className="font-display text-xl uppercase tracking-tight mb-3 leading-tight">
                {b.title}
              </h3>
              <p className="text-sm leading-relaxed text-zinc-600 group-hover:text-zinc-300 transition">
                {b.text}
              </p>
            </div>
          ))}
        </div>

        {/* Price guarantee strip */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            "Faktura VAT na firmę",
            "Płatność przelewem / za pobraniem",
            "Towar zawsze z magazynu w PL",
          ].map((item) => (
            <div
              key={item}
              className="flex items-center gap-3 p-5 border-2 border-zinc-200 bg-zinc-50"
            >
              <CheckCircle2
                className="h-6 w-6 text-red-600 shrink-0"
                strokeWidth={2}
              />
              <span className="font-tech text-sm uppercase tracking-wider text-zinc-800 font-semibold">
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
